import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroupDirective, UntypedFormControl} from '@angular/forms';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    standalone: false
})
export class DatepickerComponent implements OnInit {

  @Input() placeholder: string;
  formControl: FormControl;
  @Output() dateChange = new EventEmitter();

  constructor(private parentFormGroup: FormGroupDirective) {
  }

  @Input() min: Date;
  @Input() max: Date;
  
  @Input()
  set controlName(value: string) {
    this.formControl = this.parentFormGroup.form.get(value) as UntypedFormControl;
  }

  @Input()
  set control(formControl: UntypedFormControl) {
    this.formControl = formControl;
  }

  ngOnInit(): void {
  }
  
  startDateChange(event): void {
    this.dateChange.emit(event);
  }

}
